import { useEffect, useState } from 'react';
import { VersionDto } from '@/DTO/VersionDto';
import { useAssessmentClient, useJobTestInfoClient, useUsersClient } from '@/Hooks/ClientHooks';

function VersionPage() {
    const assessmentClient = useAssessmentClient();
    const jobTestInfoClient = useJobTestInfoClient();
    const usersClient = useUsersClient();

    const [versions, setVersion] = useState<VersionDto[]>([]);

    const getVersionsAsync = async () => {
        const v1 = await assessmentClient.getVersionAsync();
        const v2 = await jobTestInfoClient.getVersionAsync();
        const v3 = await usersClient.getVersionAsync();

        setVersion([v1, v2, v3]);
    };

    useEffect(() => {
        getVersionsAsync();
    }, []);

    return (
        <div className="flex flex-col">
            <p className="text-muted-foreground">{`app version: ${process.env.REACT_APP_VERSION}`}</p>

            {versions.map((version) => (
                <p className="text-muted-foreground" key={version.name}>
                    {version.name} : {version.version}
                </p>
            ))}
        </div>
    );
}

export default VersionPage;
